import 'src/lib/QQPhoto-master/js/QQPhoto.min.js';
/**
使用方法：
一张图：
_QQAlbum.show({
    showImgId:"",//指定id显示图片
    thumbList:[{src:$(this).attr("src"),id:""}]//[{src:"",id:""}]
});
多张图：
_QQAlbum.show({
    showImgId:"",//指定id显示图片
    thumbList:[{src:"src",id:""},{src:"src",id:""},{src:"src",id:""},{src:"src",id:""},{src:"src",id:""},{src:"src",id:""}]
});
*/

let viewPhoto = _QQAlbum;
export default viewPhoto;


// WEBPACK FOOTER //
// ./src/common/js/viewPhoto.js